import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useEmbedMode } from '@infl-ts/util-embed-mode-provider';
import fontsCss from '@influitive/infl-fonts/fonts.css?inline';
import { useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import aspectRatioCss from 'react-aspect-ratio/aspect-ratio.css?inline';
import { createPortal } from 'react-dom';
import streamChatCss from 'stream-chat-react/dist/css/index.css?inline';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GlobalStyles = function GlobalStyles(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      "data-component": "GlobalStyles",
      "data-source-file": "embed-shadow-dom.tsx",
      children: fontsCss
    }), /*#__PURE__*/_jsx("style", {
      children: aspectRatioCss
    }), /*#__PURE__*/_jsx("style", {
      children: streamChatCss
    }), children]
  });
};

var ShadowComponent = function ShadowComponent(_ref2) {
  var children = _ref2.children;
  var theme = useTheme();
  var hostRef = useRef(null);

  var _useState = useState(),
      portalDestination = _useState[0],
      setPortalDestination = _useState[1];

  var _useState2 = useState(),
      cache = _useState2[0],
      setCache = _useState2[1];

  useEffect(function () {
    var _hostRef$current$shad;

    if (!hostRef.current) return;
    var shadowDomElement = (_hostRef$current$shad = hostRef.current.shadowRoot) !== null && _hostRef$current$shad !== void 0 ? _hostRef$current$shad : hostRef.current.attachShadow({
      mode: 'open'
    });
    var portalElement = document.createElement('div');
    shadowDomElement.append(portalElement);
    setPortalDestination(portalElement);
    var styleElement = document.createElement('style');
    styleElement.innerHTML = "\n      *, ::before, ::after {\n        box-sizing: inherit;\n      }\n      :host {\n        color: ".concat(theme.palette.text.primary, ";\n        font-size: ").concat(theme.typography.body1.fontSize, ";\n        line-height: ").concat(theme.typography.body1.lineHeight, ";\n        font-family: ").concat(theme.typography.fontFamily, ";\n        font-weight: ").concat(theme.typography.fontWeightRegular, ";\n      }\n    ");
    portalElement.appendChild(styleElement);
    setCache(createCache({
      key: 'shadow-css',
      container: portalElement
    }));
  }, []);

  var shadowContent = cache && /*#__PURE__*/_jsx(CacheProvider, {
    value: cache,
    children: /*#__PURE__*/_jsx(GlobalStyles, {
      children: children
    })
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      ref: hostRef,
      "data-component": "ShadowComponent",
      "data-source-file": "embed-shadow-dom.tsx"
    }), portalDestination && /*#__PURE__*/createPortal(shadowContent, portalDestination)]
  });
};

export var EmbedShadowRoot = function EmbedShadowRoot(_ref3) {
  var children = _ref3.children;

  var _useEmbedMode = useEmbedMode(),
      isEmbedded = _useEmbedMode.isEmbedded,
      useShadowDom = _useEmbedMode.useShadowDom;

  return isEmbedded && useShadowDom ? /*#__PURE__*/_jsx(ShadowComponent, {
    children: children
  }) : isEmbedded ? /*#__PURE__*/_jsx(GlobalStyles, {
    children: children
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};